import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Entrate from "@/pages/Entrate";
import Uscite from "@/pages/Uscite";
import Partite from "@/pages/Partite";
import Report from "@/pages/Report";
import ArchivioFornitori from "@/pages/ArchivioFornitori";
import ArchivioClienti from "@/pages/ArchivioClienti";
import ArchivioProdotti from "@/pages/ArchivioProdotti";
import Backup from "@/pages/Backup";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="entrate" element={<Entrate />} />
            <Route path="uscite" element={<Uscite />} />
            <Route path="partite" element={<Partite />} />
            <Route path="report" element={<Report />} />
            <Route path="archivio/fornitori" element={<ArchivioFornitori />} />
            <Route path="archivio/clienti" element={<ArchivioClienti />} />
            <Route path="archivio/prodotti" element={<ArchivioProdotti />} />
            <Route path="backup" element={<Backup />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
